module.exports = __webpack_public_path__ + "img/sceneOne.a75e0390.png";